package org.braunequip.web.components.forms.Maintenance

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaX
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.document
import org.braunequip.web.components.forms.SubmitButton
import org.braunequip.web.components.models.MaintSchedulesDTO
import org.braunequip.web.components.models.NewMaintItemRequest
import org.braunequip.web.components.widgets.ConfirmModal
import org.braunequip.web.components.widgets.loadingSpinner
import org.braunequip.web.util.Constants.FONT_FAMILY2
import org.braunequip.web.util.InputIDs
import org.braunequip.web.util.Theme
import org.braunequip.web.util.fetchMaintenanceSchedules
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLSelectElement

@Composable
fun AddMaintenanceScheduleForm(
    assetIDList: List<Pair<Int, String>>,
    onSubmit: (NewMaintItemRequest) -> Unit,
    onDismiss: () -> Unit
) {
    val maintenanceSchedulesList = remember { mutableStateListOf<MaintSchedulesDTO>() }
    var newMaintItemRequest by remember { mutableStateOf(NewMaintItemRequest()) }
    var selectedScheduleId by remember { mutableStateOf<Int?>(null) }

    var isLoading by remember { mutableStateOf(true) }
    var showConfirmModal by remember { mutableStateOf(false) }
    var errorText by remember { mutableStateOf(" ") }

    LaunchedEffect(Unit) {
        fetchMaintenanceSchedules(
            skip = 0,
            all = true,
            onSuccess = {
                isLoading = false
                maintenanceSchedulesList.clear()
                maintenanceSchedulesList.addAll(it)
            },
            onError = {

            }
        )
    }

    Box(
        modifier = Modifier
            .width(100.vw)
            .height(100.vh)
            .position(Position.Absolute)
            .top(0.px)
            .left(0.px)
            .zIndex(19),
        contentAlignment = Alignment.TopCenter
    ) {
        Column(
            modifier = Modifier
                .backgroundColor(Colors.White)
                .borderRadius(20.px)
                .margin(top = 4.cssRem)
                .padding(1.cssRem)
                .zIndex(20)
                .width(min(700.px, 100.percent - 2.cssRem)),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Top
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.End,
                verticalAlignment = Alignment.CenterVertically
            ) {
                FaX(
                    modifier = Modifier
                        .cursor(Cursor.Pointer)
                        .onClick {
                            onDismiss()
                        }
                        .color(Colors.Grey)
                )
            }

            H2(
                attrs = Modifier
                    .fontFamily(FONT_FAMILY2)
                    .fontSize(1.25.cssRem)
                    .fontWeight(FontWeight.Bold)
                    .toAttrs()
            ) {
                Text("Adding Scheduled Maintenance")
            }

            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .margin(bottom = 16.px),
                horizontalAlignment = Alignment.Start
            ) {
                H3(
                    attrs = Modifier
                        .fontFamily(FONT_FAMILY2)
                        .fontWeight(FontWeight.Light)
                        .fontSize(1.25.cssRem)
                        .toAttrs()
                ) {
                    Text("Applying Schedule To:")
                }

                Column(
                    modifier = Modifier
                        .maxHeight(200.px)
                        .overflow(Overflow.Scroll)
                        .fillMaxWidth(),
                    horizontalAlignment = Alignment.Start,
                    verticalArrangement = Arrangement.Top
                ) {
                    assetIDList.forEach { asset ->
                        SpanText(
                            text = "${asset.first} - ${asset.second}",
                            modifier = Modifier
                                .fontFamily(FONT_FAMILY2)
                                .fontWeight(FontWeight.Light)
                                .fontSize(1.cssRem)
                        )
                    }
                }


                HorizontalDivider()

                H3(
                    attrs = Modifier
                        .fontFamily(FONT_FAMILY2)
                        .fontWeight(FontWeight.Light)
                        .fontSize(1.25.cssRem)
                        .toAttrs()
                ) {
                    Text("Select Schedule")
                }

                if (isLoading) {
                    Row(
                        Modifier
                            .height(54.px)
                            .fillMaxWidth(),
                        horizontalArrangement = Arrangement.Center
                    ) {
                        loadingSpinner()
                    }
                } else {
                    Select(
                        attrs = Modifier
                            .fillMaxWidth()
                            .id(InputIDs.MaintenanceSchedules.scheduleSelectDropdown)
                            .toAttrs()
                    ) {
                        Option(
                            value = "Select Maintenance Schedule",
                            attrs = Modifier
                                .disabled(true)
                                .toAttrs{
                                    attr("selected", "true")
                                }
                        ) {
                            Text("Select")
                        }
                        maintenanceSchedulesList.forEach { sched ->
                            Option(
                                value = sched.id.toString(),
                                attrs = Modifier
                                    .fontSize(1.cssRem)
                                    .toAttrs()
                            ) {
                                Text(
                                    "${sched.id} - ${sched.name} | Due Miles: ${sched.intervalMiles.let { it } ?: "-"} / Due Days: ${sched.intervalDays.let { it } ?: "-"}")
                            }
                        }
                    }
                }

                SpanText(
                    modifier = Modifier
                        .width(350.px)
                        .margin(top = 1.cssRem)
                        .fontFamily(FONT_FAMILY2)
                        .color(Colors.Black)
                        .textAlign(TextAlign.Center),
                    text = errorText
                )

                SubmitButton(
                    text = "SUBMIT",
                    onClick = {
                        newMaintItemRequest = newMaintItemRequest.copy(
                            scheduleId = (document.getElementById(InputIDs.MaintenanceSchedules.scheduleSelectDropdown) as HTMLSelectElement).value.toIntOrNull() ?: -1,
                            assetIds = assetIDList.map { it.first },
                        )

                        if (
                            newMaintItemRequest.scheduleId >= 0 &&
                            newMaintItemRequest.assetIds.isNotEmpty()
                        ) {
                            errorText = " "
                            showConfirmModal = true
                        } else {
                            errorText = "Please fill out all required fields correctly!"
                        }
                    },
                    modifier = Modifier
                        .margin(0.px)
                )

                if (showConfirmModal) {
                    ConfirmModal(
                        actionText = "Apply Schedule to Asset(s)?",
                        onConfirm = {
                            onSubmit(newMaintItemRequest)
                            showConfirmModal = false
                        },
                        onDismiss = {
                            showConfirmModal = false
                        }
                    )
                }
            }
        }



        Box(
            modifier = Modifier
                .fillMaxSize()
                .backgroundColor(Theme.DarkerGray.rgb)
                .position(Position.Fixed)
                .padding(top = 5.cssRem)
                .onClick {
                    onDismiss()
                }
                .zIndex(19),
            contentAlignment = Alignment.TopCenter
        )
    }
}